import "./style.css";
import { startRouter, type View } from "./router";
import { renderList } from "./views/list";
import { renderMap } from "./views/map";
import { renderSplash } from "./views/splash";
import { renderDetail } from "./views/detail";
import { renderAbout } from "./views/about";
import { initRum } from "./datadog";
import { CITY } from "./city";

const app = document.querySelector<HTMLDivElement>("#app")!;

// Defer RUM init (and its ~170KB SDK chunk) until after the page has
// finished loading and the main thread is idle, so it never competes with
// app-shell rendering for LCP/FCP. requestIdleCallback isn't available in
// Safari, hence the setTimeout fallback.
function deferInitRum(): void {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(() => void initRum());
  } else {
    setTimeout(() => void initRum(), 0);
  }
}
if (document.readyState === "complete") {
  deferInitRum();
} else {
  window.addEventListener("load", deferInitRum, { once: true });
}

function route(view: View): void {
  if (view.name === "pool") {
    void renderDetail(app, view.poolId);
    return;
  }
  if (view.name === "about") {
    renderAbout(app);
    return;
  }
  if (view.name === "splash") {
    void renderSplash(app, view.query);
    window.scrollTo(0, 0);
    return;
  }
  // Home: map when ?view=map (the #/map route); otherwise the pools List —
  // except for a splash-only city (Arlington, !features.pools), whose home is
  // the Splash list since the Pools tab is hidden.
  const tab = view.query.get("view");
  if (tab === "map") {
    void renderMap(app, view.query);
  } else if (!CITY.features.pools) {
    void renderSplash(app, view.query);
  } else {
    void renderList(app, view.query);
  }
  // Keep the page scrolled to the top across hash navigations.
  window.scrollTo(0, 0);
}

startRouter(route);

// Register service worker in production only — keeps Vite dev HMR unaffected.
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  void import("virtual:pwa-register").then(({ registerSW }) => {
    registerSW({ immediate: true });
  });
}
